import { cn } from "@/lib/utils";
import { MonoMeta } from "./Text";

// Run outcomes, oldest → newest. "past-*" render at the 0.35 tint; "missed" = didn't run.
const SEGMENT = {
  clean: "bg-os-ink",
  "past-failed": "bg-os-red/35",
  "past-flagged": "bg-os-amber/35",
  failed: "bg-os-red",
  flagged: "bg-os-amber",
  missed: "bg-os-border-strong",
};

export const countTrack = (runs) => {
  const n = (k) => runs.filter((r) => r === k || r === `past-${k}`).length;
  const [failed, flagged, missed] = [n("failed"), n("flagged"), n("missed")];
  return [
    `${n("clean")} / ${runs.length} clean`,
    failed > 0 && `${failed} failed`,
    flagged > 0 && `${flagged} flagged`,
    missed > 0 && `${missed} missed`,
  ]
    .filter(Boolean)
    .join(" · ");
};

export const Track = ({ runs, emptyLabel, className }) => {
  const none = runs.every((r) => r === "missed");
  return (
    <div className={cn("flex flex-wrap items-center gap-x-3 gap-y-2", className)}>
      <div data-testid="track" className="flex min-w-[9rem] flex-1 gap-[3px]">
        {runs.map((run, i) => (
          <span key={i} data-testid="track-segment" data-run={run} className={cn("h-[6px] flex-1 rounded-segment", SEGMENT[run])} />
        ))}
      </div>
      <MonoMeta data-testid="track-count" className="shrink-0">
        {none && emptyLabel ? emptyLabel : countTrack(runs)}
      </MonoMeta>
    </div>
  );
};
